import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './BusinessCard.css';

export default function BusinessCard() {
  const [name, setName] = useState('');
  const [title, setTitle] = useState('');
  const [company, setCompany] = useState('');
  const [resume, setResume] = useState(null);
  const [linkedIn, setLinkedIn] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [token, setToken] = useState('');

  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    if (savedToken) {
      console.log("✅ Token loaded from localStorage:", savedToken);
      setToken(savedToken);
    } else {
      console.warn("⚠️ No token found in localStorage");
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    const formData = new FormData();
    formData.append('name', name);
    formData.append('title', title);
    formData.append('company', company);
    if (resume) formData.append('resume', resume);
    formData.append('linkedIn', linkedIn);

    console.log("📦 Submitting business card with token:", token);

    try {
      const response = await fetch(`${API_BASE_URL}/businesscard/update`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
        credentials: 'include',
      });

      console.log("📡 Response status:", response.status);

      const resultText = await response.text();

      if (response.ok) {
        setMessage(resultText);
        setTimeout(() => {
          localStorage.setItem("signupProgress", "avatar");
          navigate('/avatar-customize'); // ✅ Should route here if successful
        }, 1000);
      } else {
        setMessage(`Error: ${resultText}`);
        console.error("❌ Failed to submit business card:", resultText);
      }
    } catch (error) {
      console.error('💥 Error submitting business card:', error);
      setMessage('Something went wrong while saving your business card.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="BusinessCard">
      <form onSubmit={handleSubmit}>
        <div className="name">
          <input
            type="text"
            placeholder="Enter your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="title">
          <input
            type="text"
            placeholder="Enter your Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div className="company">
          <input
            type="text"
            placeholder="Enter your Company"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            required
          />
        </div>
        <div className="resume">
          <input
            type="file"
            id="file"
            name="resume"
            accept=".pdf,.doc,.docx"
            onChange={(e) => setResume(e.target.files[0])}
          />
        </div>
        <div className="linkedIn">
          <input
            type="text"
            id="linkedIn"
            placeholder="LinkedIn URL"
            value={linkedIn}
            onChange={(e) => setLinkedIn(e.target.value)}
          />
        </div>
        <button type="submit" className="submit-button" disabled={isLoading || !token}>
          {isLoading ? 'Saving...' : 'Save Profile'}
        </button>

        {message && (
          <p
            style={{
              marginTop: '1rem',
              color: message.toLowerCase().includes('error') ? 'red' : 'green',
            }}
          >
            {message}
          </p>
        )}
      </form>
    </div>
  );
}
